// define the state model
export const TestMode = {
  // is test mode enabled?
  enabled: false,
};
